import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewChildren,
  ElementRef,
  QueryList,
} from '@angular/core';

@Component({
  selector: 'app-template8',
  templateUrl: './template8.component.html',
  styleUrls: ['./template8.component.scss'],
})
export class Template8Component {
  @Input() data: any;
  @Input() isThumbnail: boolean = false;

  @ViewChild('measureContainer') measureContainer!: ElementRef;
  @ViewChildren('sectionRefs', { read: ElementRef })
  sectionRefs!: QueryList<ElementRef>;

  allSections: any[] = [];
  pages: any[][] = [];

  ngOnInit(): void {}

  get groupedExperience(): Array<{ name: string; items: any[] }> {
    const arr = Array.isArray(this.data?.experience)
      ? this.data.experience
      : [];
    if (!arr.length) return [{ name: 'Experience', items: [] }];

    const map = new Map<string, any[]>();
    for (const e of arr) {
      const key = e.group || e.section || e.groupName || 'Experience';
      if (!map.has(key)) map.set(key, []);
      map.get(key)!.push(e);
    }
    return Array.from(map.entries()).map(([name, items]) => ({ name, items }));
  }
}
